/* eslint-disable react-hooks/rules-of-hooks */
import { makeStyles, RACCOLOR } from '@rentacenter/racstrap';

export const globalStyles = () => {
  const useClasses = makeStyles((theme) => ({
    // Existing general styles from previous implementation
    width100p: {
      width: '100%',
    },
    width15p: {
      width: '15%',
    },
    width20p: {
      width: '20%',
    },
    width10p: {
      width: '10%',
    },
    displayFlex: {
      display: 'flex',
    },
    mb20px: {
      marginBottom: '30px',
    },
    mt2px: {
      marginTop: '2px',
    },
    mt10px: {
      marginTop: '10px',
    },
    fontOpensansBold: {
      fontFamily: 'OpenSans-bold',
      fontWeight: 700,
    },
    datePicker: {
      paddingTop: '9px !important',
      marginBottom: '0px !important',
      '& div': {
        '& div': {
          '& fieldset': {
            borderColor: '#c4c4c4 !important',
          },

          '& input': {
            padding: '6px',

            paddingLeft: '12px',
          },
        },
      },
    },
    datePickerAddCo: {
      marginBottom: '0px !important',
      marginTop: '4px !important',
    },
    formLabel: {
      color: '#111111',
      fontFamily: 'OpenSans-semibold',
      fontSize: theme.typography.pxToRem(14),
    },

    // Search Results Specific Styles
    searchResultsContainer: {
      padding: theme.spacing(2),
      backgroundColor: theme.palette.background.default,
    },

    // No Records Found Styles
    noRecordsContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: theme.spacing(3),
      backgroundColor: theme.palette.grey[100],
      borderRadius: theme.shape.borderRadius,
    },

    noRecordsIcon: {
      width: 40,
      height: 40,
      marginBottom: theme.spacing(2),
    },

    noRecordsMessage: {
      textAlign: 'center',
      marginBottom: theme.spacing(2),
      color: theme.palette.text.secondary,
    },

    // Table Styles
    fullWidthTable: {
      width: '100%',
      borderCollapse: 'collapse',
      marginTop: theme.spacing(2),
    },

    tableHeader: {
      backgroundColor: theme.palette.grey[200],
      fontWeight: 600,
      '& th': {
        padding: theme.spacing(1),
        borderBottom: `1px solid ${theme.palette.divider}`,
      },
    },

    tableRow: {
      '&:nth-of-type(even)': {
        backgroundColor: theme.palette.grey[50],
      },
      '& td': {
        padding: theme.spacing(1),
        borderBottom: `1px solid ${theme.palette.divider}`,
      },
    },

    // Checkbox Styles
    checkboxCell: {
      width: '50px',
      textAlign: 'center',
    },

    // Actions Button Styles
    actionsContainer: {
      display: 'flex',
      justifyContent: 'flex-end',
      marginTop: theme.spacing(2),
    },

    actionsList: {
      position: 'absolute',
      right: 0,
      backgroundColor: theme.palette.background.paper,
      boxShadow: theme.shadows[2],
      borderRadius: theme.shape.borderRadius,
      zIndex: 10,
    },

    actionItem: {
      padding: theme.spacing(1),
      cursor: 'pointer',
      '&:hover': {
        backgroundColor: theme.palette.action.hover,
      },
    },

    // Error Text Style
    errorText: {
      color: theme.palette.error.main,
      fontSize: '14px',
      marginTop: theme.spacing(2),
    },

    // Utility Styles
    textCenter: {
      textAlign: 'center',
    },

    floatRight: {
      float: 'right',
      position: 'relative',
    },

    fontSize16px: {
      fontSize: '16px',
    },

    spacerMR2: {
      marginRight: theme.spacing(2),
    },
    spacerPT1: {
      paddingTop: theme.typography.pxToRem(16),
    },
    ssnpadding: {
      paddingTop: '9px',
    },
    ssnPaddingTop: {
      paddingTop: '4px !important',
    },
    textCenterSSN: {
      '& input': {
        textAlign: 'center',
      },
    },
    ssnTextField: {
      '& input': {
        ['@media (min-width:768px) and (max-width:1280px)']: {
          padding: '7px 9px!important',
        },
      },
    },
    mb1: {
      marginBottom: theme.typography.pxToRem(4),
    },
    ms2: {
      marginLeft: theme.typography.pxToRem(8),
    },
    p10: {
      marginTop: '12px',
    },
    pm: {
      padding: '12px 0px',
    },
    p10p25: {
      padding: '10px 25px',
    },
    mt2: {
      marginTop: '0.5rem !important',
    },
    pt4: {
      paddingTop: theme.typography.pxToRem(24),
    },
    tablecellborder: {
      borderBottom: `1px solid ${theme.palette.divider}`,
    },
    ml: {
      marginLeft: '10 px',
    },
    alignments: {
      alignItems: 'center',
      justifyContent: 'flex-end',
    },
    toast: {
      border: `1px solid ${RACCOLOR.DEEP_SKY_BLUE}`,
      borderRadius: '4px',
      padding: '10px 12px',
      backgroundColor: theme.palette.background.default,
      color: RACCOLOR.DEEP_SKY_BLUE,
      fontWeight: 'bold',
      fontSize: '14px',
      width: '150%',
    },
    masterLoader: {
      position: 'fixed',
      backgroundColor: `${RACCOLOR.WASHED_BLACK}`,
      width: '100%',
      height: '100%',
      top: 0,
      left: 0,
      opacity: 0.6,
      zIndex: 1050,
      textAlign: 'center',
      margin: 0,
    },
    Loader: {
      display: 'block',
      position: 'fixed',
      zIndex: 1051,
      top: '50%',
      right: '50%',
    },
    testclr: {
      color: RACCOLOR.DEEP_SKY_BLUE,
    },
  }));

  return useClasses();
};
